<template>
  <v-card style="height: 750px">
    <v-toolbar class="white--text" color="indigo" dense flat>
      <v-toolbar-title> Configurazione Colonne </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salva()" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Conferma</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi()" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Annulla</span>
      </v-tooltip>
    </v-toolbar>
    <v-card min-width="500px">
      <v-card-text>
        <v-data-table
          fixed-header
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="header_tabella"
        >
          <!-- Colonna del ordine up -->
          <template v-slot:[`item.ordineup`]="{ item }">
            <v-btn
              v-if="
                item.ordine < header_tabella[header_tabella.length - 1].ordine
              "
              @click="ordineUp(item)"
              small
              ><v-icon color="primary">mdi-arrow-down</v-icon></v-btn
            >
          </template>
          <!-- Colonna del ordine down -->
          <template v-slot:[`item.ordinedown`]="{ item }">
            <v-btn v-if="item.ordine > 1" @click="ordineDown(item)" small
              ><v-icon color="primary">mdi-arrow-up</v-icon></v-btn
            >
          </template>
          <!-- Descrizione -->
          <template v-slot:[`item.text`]="{ item }">
            <v-text-field hide-details v-model="item.text" />
          </template>
          <!-- Colonna del disattiva -->
          <template v-slot:[`item.visible`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.visible == 1"
                  @click="switchVisible(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="success">mdi-eye</v-icon></v-btn
                >
                <v-btn
                  v-else
                  @click="switchVisible(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="error">mdi-eye-off</v-icon></v-btn
                >
              </template>
              <span>{{ item.visible == 1 ? "Visibile" : "Nascosto" }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- Overlay -->
    <v-overlay
      color="rgba(0, 0, 0, 1)"
      style="position: absolute"
      :value="caricamento_dati"
    >
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "HeaderDetail",
  components: {
    SnackbarQV,
  },
  props: {
    modulo: { type: String, default: "" },
    tipo_valore: { type: String, default: null },
  },
  data() {
    return {
      id_utente: null,
      // overlay
      caricamento_dati: false,

      // Header fisso
      headers: [
        {
          text: "",
          sortable: false,
          value: "ordineup",
          width: "50px",
          class: "",
        },
        {
          text: "",
          sortable: false,
          value: "ordinedown",
          width: "50px",
          class: "",
        },
        {
          text: "Descrizione",
          sortable: false,
          value: "text",
          class: "",
        },
        {
          text: "Visibile",
          sortable: false,
          value: "visible",
          width: "50px",
          class: "",
        },
      ],

      // Array
      header_tabella: [],
    };
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
    },

    salvataggio_effettuato() {
      this.$emit("salvataggio_effettuato");
    },

    switchVisible(item) {
      this.header_tabella.forEach((header) => {
        if (header.id_header == item.id_header) {
          this.$set(header, "visible", !item.visible);
        }
      });
    },

    ordineUp(item) {
      // Sposto una riga dell'header di 1 valore successivo
      // e le righe con il nuovo ordine del header nodificato verrano spostate
      // nella posizione precedente.
      // Se ci sono più header con lo stesso ordine li sposto contemporaneamente.
      let ordine_spostamento = item.ordine;

      // Ordino la tabella per ottenere prima gli header da spostare nella posizione successiva
      // e successivamente quelli da spostare nella posizione precedente
      this.header_tabella.sort((a, b) => a.ordine - b.ordine);

      this.header_tabella.forEach((header) => {
        if (header.ordine == ordine_spostamento) {
          // Sposto l'ordine degli header alla posizione successiva
          this.$set(header, "ordine", header.ordine + 1);
        } else if (header.ordine == ordine_spostamento + 1) {
          // Sposto l'ordine degli header alla posizione precedente
          this.$set(header, "ordine", header.ordine - 1);
        }
      });

      this.header_tabella.sort((a, b) => a.ordine - b.ordine);
    },

    ordineDown(item) {
      // Sposto una riga dell'header di 1 valore precedente
      // e le righe con il nuovo ordine del header nodificato verrano spostate
      // nella posizione successiva.
      // Se ci sono più header con lo stesso ordine li sposto contemporaneamente.
      let ordine_spostamento = item.ordine;

      // Ordino la tabella per ottenere prima gli header da spostare nella posizione successiva
      // e successivamente quelli da spostare nella posizione precedente
      this.header_tabella.sort((a, b) => a.ordine - b.ordine);

      this.header_tabella.forEach((header) => {
        if (header.ordine == ordine_spostamento - 1) {
          // Sposto l'ordine degli header alla posizione successiva
          this.$set(header, "ordine", header.ordine + 1);
        } else if (header.ordine == ordine_spostamento) {
          // Sposto l'ordine degli header alla posizione precedente
          this.$set(header, "ordine", header.ordine - 1);
        }
      });

      this.header_tabella.sort((a, b) => a.ordine - b.ordine);
    },

    salva() {
      // Se l'utente corrente non ha ancora un elemento dell'header salvato con il suo id
      // creo un nuovo header.
      if(!this.id_utente) {
        console.log("Impossibile salvare: utente non identificato.");
        return;
      }

      this.header_tabella.forEach((header) => {
        if (header.id_utente == null) {
          header.id_header = -1;
          header.id_utente = this.id_utente;
        }
      });

      let request = {
        controller: "contabilita",
        method: "PUT",
        richiesta: {
          action: "setheader",
          token: localStorage.getItem("user_token"),
          headers: this.header_tabella,
        },
      };

      this.caricamento_dati = true;

      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.data.statusCode === 200) {
            this.caricamento_dati = false;
            this.$refs.SnackbarQV.print(
              "success",
              "Salvataggio effettuato con successo."
            );
            // Ricarico gli header
            this.getTabellaHeader();
            // genero l'evento di salvataggio effettuato
            this.salvataggio_effettuato();
          } else {
            console.log("error: " + res.data.statusCode);
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          ); // Stampo il log dell'errore in console.
          console.error(err);
        });
    },

    getTabellaHeader() {
      let request = {
        controller: "contabilita",
        method: "POST",
        richiesta: {
          action: "getheaderlista",
          token: localStorage.getItem("user_token"),
          tipo_valore: this.tipo_valore,
          modulo: this.modulo,
        },
      };

      this.caricamento_dati = true;

      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.data.statusCode === 200) {
            this.caricamento_dati = false;
            this.header_tabella = res.data.result ? res.data.result : [];

            if (this.header_tabella) {
              this.header_tabella.sort((a, b) => a.ordine - b.ordine);
              // Per evitare doppioni con il campo ordine sovrascivo il valore in base all'index
              let index = 1;
              this.header_tabella.forEach((header) => {
                header.ordine = index;
                index = index + 1;
              });
            }
          } else {
            console.log("error: " + res.data.statusCode);
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          ); // Stampo il log dell'errore in console.
          console.error(err);
        });
    },

    async getUtente() {
      let request = {
          controller: "Global",
          method: "POST",
          richiesta: {
              action: "getutenteattuale",
              token: localStorage.getItem("user_token"),
          },
      };

      return this.$store.dispatch("api6", request)
      .then((res) => {
        if (res.status === 200) {
          this.id_utente = res.data.result.id_utente;
          console.log(this.id_utente);
          return true;
        } else {
          return false;
        }
      }).catch((err) => {
        console.log(err);
        return false;
      });
    }
  },

  computed: {},

  watch: {},

  async mounted() {
    await this.getUtente();
    this.getTabellaHeader();
  },
};
</script>
